import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["customValue", "value", "name", "onChange", "addressSelectContainerClass", "showDisplayLabel", "useStateReducer"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context4, _context5; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context4 = ownKeys(Object(t), !0)).call(_context4, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context5 = ownKeys(Object(t))).call(_context5, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.function.name.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
//@ts-nocheck
import * as React from "react";
import AutoCompleteInput from "../../Fields/AutoComplete/AutoCompleteInput";
import Downshift from "downshift";
import { jsx as _jsx } from "react/jsx-runtime";
var GoogleMapsAddressSelect = /*#__PURE__*/function (_React$Component) {
  /**
   * Called on the client side after component is mounted.
   * Google api sdk object will be obtained and cached as a instance property.
   * Necessary objects of google api will also be determined and saved.
   */
  function GoogleMapsAddressSelect(props) {
    var _this;
    _classCallCheck(this, GoogleMapsAddressSelect);
    _this = _callSuper(this, GoogleMapsAddressSelect, [props]);
    /**
     * The Google Map instance
     */
    _defineProperty(_this, "googleMaps", null);
    /**
     * The autocomple service to get suggests
     */
    _defineProperty(_this, "autocompleteService", null);
    /**
     * The geocoder to get geocoded results
     */
    _defineProperty(_this, "geocoder", null);
    /**
     * The places service to get place details
     */
    _defineProperty(_this, "placesService", null);
    /**
     * The sessionToken service to use session based monetization
     */
    _defineProperty(_this, "sessionToken", null);
    _defineProperty(_this, "searchSuggests", function (input) {
      _this.setState({
        inputValue: input
      }, function () {
        if (!input) {
          _this.props.onChange({
            target: {
              name: _this.props.name,
              value: ""
            }
          });
          return;
        }
        var _this$props = _this.props,
          _this$props$location = _this$props.location,
          location = _this$props$location === void 0 ? new _this.googleMaps.LatLng(37.784625, -122.4087047) : _this$props$location,
          _this$props$radius = _this$props.radius,
          radius = _this$props$radius === void 0 ? 10 * 1690 : _this$props$radius,
          types = _this$props.types,
          _this$props$country = _this$props.country,
          country = _this$props$country === void 0 ? "us" : _this$props$country;
        var options = {
          input: input,
          radius: radius,
          types: types,
          location: location
        };
        if (!_this.autocompleteService) {
          _this.setState({
            suggests: []
          });
          return;
        }
        _this.autocompleteService.getPlacePredictions(options, function (suggestsGoogle) {
          _this.setState({
            suggests: suggestsGoogle || []
          });
        });
      });
    });
    _defineProperty(_this, "onSuggestSelect", function (suggest) {
      if (!suggest || suggest.location) {
        _this.props.onChange({
          target: {
            name: _this.props.name,
            value: suggest
          }
        });
      } else {
        _this.geocodeSuggest(suggest);
      }
    });
    /**
     * Geocode a suggest
     */
    _defineProperty(_this, "geocodeSuggest", function (suggestToGeocode) {
      var _this$props2 = _this.props,
        _this$props2$location = _this$props2.location,
        location = _this$props2$location === void 0 ? new _this.googleMaps.LatLng(37.784625, -122.4087047) : _this$props2$location,
        name = _this$props2.name,
        onChange = _this$props2.onChange;
      var options = {
        placeId: suggestToGeocode.place_id,
        // Use the new forward geocoder
        // As of recent updates (this was discussed in a blog post for a "new" geocoder service), 
        // setting this to true might enable the use of a newer forward geocoding engine within the JavaScript API's Geocoding Service. 
        // This can sometimes provide improved quality for ambiguous or incomplete queries.
        newForwardGeocoder: true
      };
      _this.geocoder.geocode(options, function (results, status) {
        if (status === _this.googleMaps.GeocoderStatus.OK) {
          var closestResults = _sortInstanceProperty(results).call(results, compareGooglePlaceResults);
          var _location = closestResults[0].geometry.location;
          var addressComponents = closestResults[0].address_components;
          var suggest = _objectSpread(_objectSpread({}, suggestToGeocode), {}, {
            addressComponents: addressComponents,
            location: {
              lat: _location.lat(),
              lng: _location.lng()
            }
          });
          onChange({
            target: {
              name: name,
              value: suggest
            }
          });
        }
      });
    });
    _defineProperty(_this, "stateReducer", function (state, changes) {
      if (changes.type === Downshift.stateChangeTypes.clickItem) {
        return _objectSpread(_objectSpread({}, changes), {}, {
          inputValue: ''
        });
      }
      return changes;
    });
    if (typeof window === "undefined") {
      return _possibleConstructorReturn(_this);
    }
    var googleMaps = window.google && window.google.maps || _this.googleMaps;
    if (!googleMaps) {
      if (console) {
        console.error("Google maps API was not found in the page.");
      }
      return _possibleConstructorReturn(_this);
    }
    _this.googleMaps = googleMaps;
    _this.autocompleteService = new googleMaps.places.AutocompleteService();
    _this.placesService = new googleMaps.places.PlacesService(document.createElement("div"));
    _this.sessionToken = new googleMaps.places.AutocompleteSessionToken();
    _this.geocoder = new googleMaps.Geocoder();
    _this.state = {
      suggests: [],
      inputValue: props.useStateReducer ? "" : props.value
    };
    return _this;
  }
  _inherits(GoogleMapsAddressSelect, _React$Component);
  return _createClass(GoogleMapsAddressSelect, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevValueIsNull = prevProps.value === "" || prevProps.value == null;
      var valueIsNull = this.props.value === "" || this.props.value == null;
      if (valueIsNull && !prevValueIsNull) {
        this.setState({
          inputValue: ""
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        customValue = _this$props3.customValue,
        value = _this$props3.value,
        name = _this$props3.name,
        onChange = _this$props3.onChange,
        addressSelectContainerClass = _this$props3.addressSelectContainerClass,
        showDisplayLabel = _this$props3.showDisplayLabel,
        useStateReducer = _this$props3.useStateReducer,
        rest = _objectWithoutProperties(_this$props3, _excluded);
      var _this$state = this.state,
        suggests = _this$state.suggests,
        inputValue = _this$state.inputValue;
      return /*#__PURE__*/_jsx("div", {
        className: addressSelectContainerClass,
        children: /*#__PURE__*/_jsx(AutoCompleteInput, _objectSpread({
          DownshiftProps: {
            onInputValueChange: this.searchSuggests,
            initialInputValue: value,
            onChange: this.onSuggestSelect,
            itemToString: function itemToString(item) {
              return item ? item.description : "";
            },
            stateReducer: useStateReducer ? this.stateReducer : undefined
          },
          suggestions: suggests,
          inputProps: {
            customValue: inputValue
          }
        }, rest))
      });
    }
  }]);
}(React.Component);
/*
 * For a given search, google may return multiple addresses.
 *
 * Since this is a very rare case, we can use the place type as a heuristic.
 * The `premise` type is the most accurate for our needs
 * https://googlemaps.github.io/google-maps-services-java/v0.1.3/javadoc/com/google/maps/model/AddressType.html
 *
 */
export { GoogleMapsAddressSelect as default };
function compareGooglePlaceResults(a, b) {
  var _context, _context2, _context3;
  if (_includesInstanceProperty(_context = a.types).call(_context, "premise") && _includesInstanceProperty(_context2 = b.types).call(_context2, "premise")) {
    return 0;
  } else if (_includesInstanceProperty(_context3 = a.types).call(_context3, "premise")) {
    // premise is stronger so order it first
    return -1;
  } else {
    return 1;
  }
}